(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ghost-conversion"] && !Shopify.designMode) return;
  try {
    
  const fmt = n => '$' + n.toLocaleString('es-CO');
  const root = document.querySelector('.dv-lp') || document;
  const tiers = root.querySelectorAll('.tier');
  const stickyL1 = document.getElementById('stickyL1');
  const stickyL2 = document.getElementById('stickyL2');
  const ctaPrice = document.getElementById('ctaInlinePrice');
  const COLORS=[{hex:'#C7B299',name:'Arena'},{hex:'#EBE4D5',name:'Blanco Lino'},{hex:'#8FA3BC',name:'Azul Bahía'},{hex:'#7C8568',name:'Verde Oliva'},{hex:'#855B45',name:'Mocca'},{hex:'#262626',name:'Negro Carbón'}];
  const SIZES=['S','M','L','XL'];
  const builder=document.getElementById('builder');
  const summary=document.getElementById('summary');
  let pack=[];

  // ===== Variantes reales, leídas del producto (isla JSON generada por Liquid) =====
  // Nunca IDs quemados: si el producto se recrea, el mapa se regenera solo.
  const norm = s => (s||'').toString().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  let VARIANTS = {};
  try{
    const isla = root.querySelector('[data-dv-variantes]');
    const data = JSON.parse(isla.textContent);
    data.variants.forEach(v=>{
      const c = norm(v.opts[data.colorIdx]);
      const t = norm(v.opts[data.tallaIdx]);
      (VARIANTS[c]=VARIANTS[c]||{})[t]={id:v.id, disponible:v.disponible};
    });
    if(!data.variants.length){ console.error('[lp-juanda] La isla de variantes llegó vacía: la sección no está en un template de producto y no se configuró "Producto del pack".'); }
  }catch(e){ console.error('[lp-juanda] No se pudo leer la isla de variantes', e); }
  function variantFor(colorName, sizeName){
    return (VARIANTS[norm(colorName)]||{})[norm(sizeName)] || null;
  }

  // ===== Fotos de modelo por color (isla JSON desde Archivos de Shopify; fallback: silueta) =====
  let FOTOS = {};
  try{
    const islaF = root.querySelector('[data-dv-fotos]');
    if(islaF){
      const raw = JSON.parse(islaF.textContent);
      Object.keys(raw).forEach(k=>{ if(raw[k] && raw[k].t){ FOTOS[norm(k)] = raw[k]; } });
    }
  }catch(e){ console.error('[lp-juanda] No se pudo leer la isla de fotos por color', e); }
  const FOTOS_CAIDAS = new Set();
  function photoFor(ci){ const k=norm(COLORS[ci].name); if(FOTOS_CAIDAS.has(k)) return null; return FOTOS[k] || null; }
  function marcarFotoCaida(img, btn){ if(img&&img.dataset.k) FOTOS_CAIDAS.add(img.dataset.k); if(btn) btn.style.display='none'; }
  function setSlotPhoto(slot, ci){
    const btn=slot.querySelector('.slot-photo'); if(!btn) return;
    const ph=photoFor(ci);
    if(!ph||!ph.t){ btn.style.display='none'; return; }
    btn.style.display='';
    btn.setAttribute('aria-label','Ver foto del color '+COLORS[ci].name);
    let img=btn.querySelector('img');
    if(!img){ img=document.createElement('img'); img.loading='lazy'; img.addEventListener('error',()=>marcarFotoCaida(img,btn)); btn.appendChild(img); }
    img.style.opacity=.35;
    img.onload=()=>{ img.style.opacity=1; };
    img.dataset.k=norm(COLORS[ci].name);
    img.src=ph.t; img.alt='Modelo con la camiseta en '+COLORS[ci].name;
    if(img.complete && img.naturalWidth>0) img.style.opacity=1;
  }
  let photoModalReturnFocus=null;
  function closePhotoModal(){
    const m=document.getElementById('photoModal'); if(m) m.classList.remove('open');
    if(photoModalReturnFocus){ try{ photoModalReturnFocus.focus(); }catch(e){} photoModalReturnFocus=null; }
  }
  function openPhotoModal(ci){
    const ph=photoFor(ci); if(!ph||!ph.f) return;
    const m=document.getElementById('photoModal'); if(!m) return;
    const img=document.getElementById('photoModalImg');
    img.removeAttribute('src');
    img.dataset.k=norm(COLORS[ci].name);
    img.src=ph.f; img.alt='Modelo con la camiseta en '+COLORS[ci].name;
    document.getElementById('photoModalLabel').textContent=COLORS[ci].name;
    photoModalReturnFocus=document.activeElement;
    m.classList.add('open');
    const x=document.getElementById('photoModalX'); if(x) x.focus();
  }

  function renderBuilder(qty){
    for(let i=0;i<qty;i++){ if(!pack[i]) pack[i]={c:i%COLORS.length,s:1}; }
    pack.length=qty;
    let h='<div class="bhead"><span>Arma tu pack · '+qty+(qty>1?' camisetas':' camiseta')+'</span><a href="#" class="szguide">Guía de tallas</a></div>';
    pack.forEach((p,i)=>{
      h+='<div class="slot" data-i="'+i+'"><div class="slot-grid"><div class="slot-main"><div class="slot-top">';
      h+='<div class="slot-info"><div class="slot-t">Camiseta '+(i+1)+'</div><div class="slot-sel">'+COLORS[p.c].name+' · talla '+SIZES[p.s]+'</div></div></div><div class="swrow">';
      COLORS.forEach((c,ci)=>{ h+='<div class="sw2'+(ci===p.c?' sel':'')+'" data-c="'+ci+'" style="background:'+c.hex+'" title="'+c.name+'"></div>'; });
      h+='</div><div class="szrow">';
      SIZES.forEach((s,si)=>{ h+='<div class="sz'+(si===p.s?' sel':'')+'" data-s="'+si+'">'+s+'</div>'; });
      h+='</div></div>';
      const ph=photoFor(p.c);
      h+='<button type="button" class="slot-photo"'+(ph&&ph.t?'':' style="display:none"')+' aria-label="Ver foto del color '+COLORS[p.c].name+'">'+(ph&&ph.t?'<img src="'+ph.t+'" data-k="'+norm(COLORS[p.c].name)+'" alt="Modelo con la camiseta en '+COLORS[p.c].name+'" loading="lazy">':'')+'</button>';
      h+='</div></div>';
    });
    builder.innerHTML=h;
    const sg=builder.querySelector('.szguide');
    if(sg) sg.addEventListener('click',e=>{e.preventDefault();document.getElementById('sizeModal').classList.add('open');});
    builder.querySelectorAll('.slot').forEach(slot=>{
      const i=+slot.dataset.i;
      const label=()=>slot.querySelector('.slot-sel').textContent=COLORS[pack[i].c].name+' · talla '+SIZES[pack[i].s];
      slot.querySelectorAll('.sw2').forEach(sw=>sw.addEventListener('click',()=>{
        pack[i].c=+sw.dataset.c;
        slot.querySelectorAll('.sw2').forEach(x=>x.classList.remove('sel')); sw.classList.add('sel');
        setSlotPhoto(slot, pack[i].c); label(); renderSummary();
      }));
      slot.querySelectorAll('.sz').forEach(sz=>sz.addEventListener('click',()=>{
        pack[i].s=+sz.dataset.s;
        slot.querySelectorAll('.sz').forEach(x=>x.classList.remove('sel')); sz.classList.add('sel'); label(); renderSummary();
      }));
      const pbtn=slot.querySelector('.slot-photo');
      if(pbtn){
        pbtn.addEventListener('click',()=>openPhotoModal(pack[i].c));
        const pim=pbtn.querySelector('img');
        if(pim) pim.addEventListener('error',()=>marcarFotoCaida(pim,pbtn));
      }
    });
    renderSummary();
  }
  function renderSummary(){
    const selTier=root.querySelector('.tier.sel'); if(!selTier) return;
    const total=+selTier.dataset.total;
    let h='<div class="sum-h">Tu pedido</div>';
    pack.forEach((p,i)=>{ h+='<div class="sum-row"><span class="k">Camiseta '+(i+1)+'</span><span class="v">'+COLORS[p.c].name+' · '+SIZES[p.s]+'</span></div>'; });
    h+='<div class="sum-row sum-total"><span class="k">Total</span><span class="v">'+fmt(total)+'</span></div>';
    summary.innerHTML=h;
  }

  function select(tier){
    tiers.forEach(t => t.classList.remove('sel'));
    tier.classList.add('sel');
    const qty = +tier.dataset.qty, unit = +tier.dataset.unit, total = +tier.dataset.total;
    stickyL1.textContent = qty + (qty>1?' camisetas':' camiseta') + ' · ' + fmt(total);
    stickyL2.innerHTML = fmt(unit) + ' <span class="cu">c/u</span>';
    ctaPrice.textContent = fmt(total);
    renderBuilder(qty);
  }
  tiers.forEach(t => t.addEventListener('click', () => { select(t); scrollToBuilder(); }));
  function scrollToBuilder(){ const head = builder.querySelector('.bhead'); if(head) head.scrollIntoView({behavior:'smooth', block:'start'}); }
  renderBuilder(3);
  // Precarga de las 6 miniaturas: renderBuilder reconstruye el DOM al cambiar de tier y sin
  // esto las fotos parpadean en cada redibujado.
  Object.values(FOTOS).forEach(ph=>{ if(ph && ph.t){ const im=new Image(); im.src=ph.t; } });

  root.querySelectorAll('#faq .qq').forEach(q => {
    q.addEventListener('click', () => q.parentElement.classList.toggle('open'));
  });

  // Carrusel de diferenciación: se desliza a mano, sin autoplay (motion sereno).
  const difTrack=document.getElementById('difTrack');
  if(difTrack){
    const difBars=Array.from(root.querySelectorAll('.dif-bars span'));
    const difCopies=Array.from(root.querySelectorAll('.dif-copy'));
    let difIdx=0;
    const difPaint=()=>{
      difBars.forEach((b,bi)=>b.classList.toggle('on',bi<=difIdx));
      difCopies.forEach((c,ci)=>c.classList.toggle('sel',ci===difIdx));
    };
    difPaint();
    difTrack.addEventListener('scroll',()=>{
      const i=Math.round(difTrack.scrollLeft/difTrack.clientWidth);
      if(i!==difIdx && i>=0 && i<difCopies.length){ difIdx=i; difPaint(); }
    },{passive:true});
  }

  const sizeModal=document.getElementById('sizeModal');
  const sg2=root.querySelector('.szguide2');
  if(sg2) sg2.addEventListener('click',e=>{e.preventDefault();sizeModal.classList.add('open');});
  document.getElementById('sizeModalX').addEventListener('click',()=>sizeModal.classList.remove('open'));
  sizeModal.addEventListener('click',e=>{if(e.target===sizeModal)sizeModal.classList.remove('open');});

  const photoModal=document.getElementById('photoModal');
  if(photoModal){
    document.getElementById('photoModalX').addEventListener('click',closePhotoModal);
    photoModal.addEventListener('click',e=>{if(e.target===photoModal)closePhotoModal();});
    const pmImg=document.getElementById('photoModalImg');
    pmImg.addEventListener('error',()=>{ if(pmImg.dataset.k) FOTOS_CAIDAS.add(pmImg.dataset.k); closePhotoModal(); });
  }
  document.addEventListener('keydown',e=>{ if(e.key==='Escape'){ closePhotoModal(); sizeModal.classList.remove('open'); } });

  function setBuying(on){
    const s=document.getElementById('stickyBuy'), i=document.getElementById('ctaInline');
    if(s){ s.disabled=on; s.textContent = on ? 'Agregando…' : 'Comprar ahora'; }
    if(i){ i.disabled=on; }
  }
  async function buy(){
    const counts={};
    for(const p of pack){
      const nombreColor=COLORS[p.c].name, nombreTalla=SIZES[p.s];
      const v=variantFor(nombreColor, nombreTalla);
      if(!v){
        console.error('[lp-juanda] Combinación sin variante en la tienda:', nombreColor, nombreTalla, 'Disponibles:', Object.keys(VARIANTS));
        alert('No encontramos la combinación '+nombreColor+' · '+nombreTalla+' en la tienda. Prueba otra combinación o escríbenos por WhatsApp.');
        return;
      }
      if(!v.disponible){
        alert('La '+nombreColor+' en talla '+nombreTalla+' está agotada. Elige otra combinación.');
        return;
      }
      counts[v.id]=(counts[v.id]||0)+1;
    }
    const items=Object.keys(counts).map(id=>({id:Number(id), quantity:counts[id]}));
    setBuying(true);
    try{
      await fetch('/cart/clear.js',{method:'POST',headers:{'Content-Type':'application/json'}});
      const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
      if(!r.ok){ const txt=await r.text(); console.error('[lp-juanda] cart/add falló', r.status, txt); throw 0; }
      setBuying(false);
      // Flujo canónico (biblia de la landing): abrir el drawer del carrito con las dos vías de pago.
      if(document.querySelector('cart-drawer')){
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh',{bubbles:true}));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      } else {
        window.location.href='/cart';
      }
    }catch(e){
      setBuying(false);
      alert('No pudimos agregar el pack al carrito. Revisa tu conexión e intenta de nuevo.');
    }
  }
  // El botón flotante de Releasit queda apagado en esta landing (decisión de Esteban 2026-08-15:
  // un solo CTA flotante, la vía COD vive en el drawer). El toggle del panel de la app sigue
  // encendido; este cinturón cubre también navegadores sin :has(). El botón COD del drawer NO
  // se toca.
  const rsiFabKill = ()=>{ document.querySelectorAll('body > [id^="floatingBuyNow"]').forEach(el=>{ if(el.style.display!=='none') el.style.setProperty('display','none','important'); }); };
  rsiFabKill();
  new MutationObserver(rsiFabKill).observe(document.body,{childList:true,attributes:true,attributeFilter:['style'],subtree:true});

  document.getElementById('stickyBuy').addEventListener('click', buy);
  document.getElementById('ctaInline').addEventListener('click', buy);
  document.getElementById('ctaFinal').addEventListener('click', () => {
    document.getElementById('tiers').scrollIntoView({behavior:'smooth',block:'center'});
  });

  // ══ Medición en Microsoft Clarity + salto al builder (2026-09-01) ══════════
  // Todo lo de aquí abajo es ADITIVO: ningún listener cancela, previene ni
  // redirige nada. No se toca ninguna URL — la pauta está encendida y el enlace
  // de las campañas no cambia.
  const dvC   = (t, a, b) => { if (window.clarity) { try { window.clarity(t, a, b); } catch (e) {} } };
  const dvTag = (k, v) => dvC('set', k, String(v));
  const dvEv  = n => dvC('event', n);
  let dvVigia = null;
  let dvCodT0 = 0;

  // ── Etiquetas de sesión ────────────────────────────────────────────────────
  // El origen se deduce en el navegador (fbclid / referrer) a propósito: así se
  // puede segmentar por fuente sin añadir UTMs al enlace de las campañas.
  (function dvEtiquetasDeSesion () {
    const suf = (document.body.className.match(/template-suffix-([a-z0-9-]+)/) || [])[1] || 'sin-suffix';
    dvTag('dv_pagina', 'landing-' + suf);
    const p = new URLSearchParams(location.search);
    const ref = document.referrer || '';
    const origen =
      (p.has('fbclid') || /facebook|instagram/i.test(ref)) ? 'meta' :
      (p.has('ttclid') || /tiktok/i.test(ref))             ? 'tiktok' :
      (p.has('gclid')  || /google/i.test(ref))             ? 'google' :
      p.get('utm_source')                                   ? p.get('utm_source').slice(0, 40) :
      (ref && ref.indexOf(location.host) === -1)            ? 'referido' : 'directo';
    dvTag('dv_origen', origen);
    dvTag('dv_dispositivo', innerWidth < 480 ? 'xs' : innerWidth < 768 ? 'sm' : innerWidth < 1100 ? 'md' : 'lg');
  })();

  // ── Salto al builder desde el hero y la ficha de especificaciones ──────────
  // Clarity mostró clics muertos sobre ambos: ninguno era clicable. Ahora
  // llevan a armar el pack con el MISMO scroll que ya usan los tiers.
  const dvSaltarAlBuilder = origen => e => {
    if (e.target.closest && e.target.closest('a,button,input,select,summary')) return;
    scrollToBuilder();
    dvEv('dv_lp_salto_' + origen);
  };
  // OJO: el <video> del hero vive dentro de un <template> en deferred-media y
  // todavía no existe cuando corre esto. Se engancha la SECCIÓN, no el video.
  const dvSec  = root.closest ? root.closest('.shopify-section') : null;
  const dvHero = dvSec && dvSec.previousElementSibling;
  if (dvHero && dvHero.classList && dvHero.classList.contains('shopify-section')
      && !/header|announcement/i.test(dvHero.id)) {
    dvHero.style.cursor = 'pointer';
    dvHero.addEventListener('click', dvSaltarAlBuilder('hero'));
  }
  const dvSpecs = root.querySelector('.specs');
  if (dvSpecs) {
    dvSpecs.style.cursor = 'pointer';
    dvSpecs.setAttribute('role', 'button');
    dvSpecs.setAttribute('tabindex', '0');
    dvSpecs.setAttribute('aria-label', 'Ir a armar tu pack');
    dvSpecs.addEventListener('click', dvSaltarAlBuilder('specs'));
    dvSpecs.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dvSaltarAlBuilder('specs')(e); }
    });
  }

  // ── El logo deja de ser un enlace ──────────────────────────────────────────
  // pointer-events:none frena el ratón pero NO el teclado: un Tab + Enter seguía
  // saliendo al home. Quitar el href lo saca del recorrido y del árbol de
  // accesibilidad como enlace, sin tocar la marca ni el layout.
  document.querySelectorAll('.logo__link').forEach(a => {
    a.removeAttribute('href');
    a.style.cursor = 'default';
  });

  // ── Configuración del pack ─────────────────────────────────────────────────
  // Delegado en root porque renderBuilder rehace el DOM en cada cambio de tier.
  root.addEventListener('click', e => {
    const t = e.target;
    if (!t.closest) return;
    const tier = t.closest('.tier');
    if (tier) { dvEv('dv_lp_tier'); dvTag('dv_tier', tier.dataset.qty || '?'); }
    if (t.closest('.sw2'))                dvEv('dv_lp_color');
    if (t.closest('.sz'))                 dvEv('dv_lp_talla');
    if (t.closest('.szguide, .szguide2')) dvEv('dv_lp_guia_tallas');
    if (t.closest('.slot-photo'))         dvEv('dv_lp_foto_color');
    if (t.closest('#faq .qq'))            dvEv('dv_lp_faq');
  }, true);

  // ── Compra: intención, éxito y FRACASO ─────────────────────────────────────
  // buy() aborta con alert() nativo si falta la variante, si está agotada o si
  // falla el carrito. Un alert es invisible para Clarity: la grabación solo
  // muestra la página quieta. Este vigía lo hace visible sin tocar buy().
  const dvCompraIntentada = cual => {
    dvEv('dv_lp_comprar');
    dvTag('dv_cta', cual);
    clearTimeout(dvVigia);
    dvVigia = setTimeout(() => { dvVigia = null; dvEv('dv_lp_compra_fallida'); }, 9000);
  };
  document.getElementById('ctaInline').addEventListener('click', () => dvCompraIntentada('inline'));
  document.getElementById('stickyBuy').addEventListener('click', () => dvCompraIntentada('sticky'));
  document.addEventListener('dispatch:cart-drawer:open', () => {
    if (!dvVigia) return;               // el drawer también se abre desde el header
    clearTimeout(dvVigia);
    dvVigia = null;
    dvEv('dv_lp_agregado');
  });

  // ── Drawer y contra entrega: donde esta landing convierte de verdad ────────
  document.addEventListener('click', e => {
    const t = e.target;
    if (!t.closest || !e.isTrusted) return;
    if (t.closest('.checkout-buttons a')) { dvEv('dv_drawer_pagar_online'); dvTag('dv_via', 'online'); }
    if (t.closest('#rsi_buy_now_button')) { dvEv('dv_drawer_pagar_cod'); dvTag('dv_via', 'cod'); dvCodT0 = Date.now(); }
    if (t.closest('#rsi_form_wrapper [class*="rsi-submit"], #rsi_form_wrapper button[type="submit"]')) dvEv('dv_cod_enviado');
  }, true);

  // El formulario COD de Releasit carga en diferido (~4 s en frío): medimos la
  // espera real y avisamos si abre sin pintarse (ya pasó dos veces).
  new MutationObserver(() => {
    const d = document.querySelector('#rsi_form_wrapper[open]');
    if (!d || d.dataset.dvVisto) return;
    d.dataset.dvVisto = '1';
    dvEv('dv_cod_form_abierto');
    if (dvCodT0 && Date.now() - dvCodT0 > 2500) dvEv('dv_cod_espera_larga');
    if (d.checkVisibility && !d.checkVisibility()) dvEv('dv_cod_form_invisible');
  }).observe(document.body, { childList: true, subtree: true, attributeFilter: ['open'] });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
